import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { createLDReactProvider } from "@launchdarkly/react-sdk";
import { FacebookPixelProvider } from "react-facebook";
import { App } from "./App";
import { getOrCreateDeviceId } from "./lib/deviceId";
import { TikTokPixelProvider } from "./lib/TikTokPixelProvider";
import { AmplitudeProvider } from "./lib/AmplitudeProvider";
import "@radix-ui/themes/styles.css";
import "@fontsource/tiktok-sans/300.css";
import "@fontsource/tiktok-sans/400.css";
import "@fontsource/tiktok-sans/500.css";
import "@fontsource/tiktok-sans/600.css";
import "./styles.css";
import "./routes/routes.css";

const deviceId = getOrCreateDeviceId();

const LDProvider = createLDReactProvider(
  import.meta.env.VITE_PUBLIC_LAUNCHDARKLY_CLIENT_ID,
  { kind: "device_id", key: deviceId },
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <LDProvider>
          <AmplitudeProvider
            apiKey={import.meta.env.VITE_PUBLIC_AMPLITUDE_API_KEY}
            deviceId={deviceId}
          >
            <FacebookPixelProvider
              pixelId={import.meta.env.VITE_PUBLIC_FACEBOOK_PIXEL_ID}
            >
              <TikTokPixelProvider
                pixelId={import.meta.env.VITE_PUBLIC_TIKTOK_PIXEL_ID}
              >
                <App />
              </TikTokPixelProvider>
            </FacebookPixelProvider>
          </AmplitudeProvider>
        </LDProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
